import { AvatarUploader, Icon, InputText, Loading } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import {
  useGetUserProfileQuery,
  useUpdateProfileUserMutation,
  useUserUploadAvatarMutation,
} from 'services';

import { structure } from './config';
import ModalMyRefferal from './ModalMyRefferal';

const UserInfoFeature = () => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const { data, isLoading } = useGetUserProfileQuery();

  const {
    data: dataUploadFile,
    isLoading: isLoadingMutateAvtAsync,
    isError,
    mutateAsync: mutateAvatarAsync,
  } = useUserUploadAvatarMutation();

  const { isLoading: isLoadingMutateProfile, mutateAsync: mutateProfileAsync } =
    useUpdateProfileUserMutation();

  const [avatarFile, setAvatarFile] = useState<File>();

  const handleOnSubmit = async (values: any) => {
    const { email } = values;
    let dataMutateAvatarAsync;
    try {
      if (avatarFile) {
        // AN STT UPD
        // await mutateAvatarAsync({ extention: avatarFile?.type as string, file: avatarFile as File });
        let fileExtension = avatarFile?.type.substring(
          avatarFile?.type.indexOf('/') + 1,
          avatarFile?.type.length,
        );
        dataMutateAvatarAsync = await mutateAvatarAsync({
          extention: fileExtension as string,
          file: avatarFile as File,
        });
      }
      await mutateProfileAsync({
        email,
        ...(avatarFile &&
          dataMutateAvatarAsync &&
          !isError && { avatar: dataMutateAvatarAsync?.url }),
      });
      // AN END UPD
      toast.success('Cập nhật thông tin thành công');
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const { handleSubmit, getInputProps } = useForm({
    enableReinitialize: true,
    structure: structure(data),
    onSubmit: handleOnSubmit,
  });

  return (
    <div className='user-detail'>
      <Loading isLoading={isLoading}>
        <div className='user-detail-wrapper'>
          <div className='primary-info__col'>
            <div className='primary-info__general-info'>
              <form
                className='primary-info__general-info__field'
                onSubmit={handleSubmit}
              >
                <div className='secondary-info__wrapper'>
                  <div className='secondary-info'>
                    <div className='secondary-info__avatar-section'>
                      <div className='secondary-info__avatar-section__avatar'>
                        {/* <InputWraper
                            inputProps={getInputProps('avatar')}
                            component={InputImageSingle}
                            className="secondary-info__avatar-section__avatar__img"
                          /> */}
                        <Loading isLoading={isLoadingMutateAvtAsync}>
                          <AvatarUploader
                            onChangeCallback={setAvatarFile}
                            avatar={data?.avatar}
                          />
                        </Loading>
                      </div>
                      <div className='secondary-info__avatar-section__info'>
                        <div className='secondary-info__avatar-section__info__name'>
                          {data?.fullName ?? 'N/A'}
                        </div>
                        <div className='secondary-info__avatar-section__info__phone'>
                          {data?.phoneNumber ?? 'N/A'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label='Tên tài khoản'
                      inputProps={getInputProps('fullName')}
                      component={InputText}
                    />
                  </div>

                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label='Số điện thoại'
                      inputProps={getInputProps('phoneNumber')}
                      component={InputText}
                    />
                  </div>

                  <div className='cFCaol-sm-6 col-lg-4'>
                    <InputWraper
                      label='CCCD/MST'
                      inputProps={getInputProps('citizenIdentityCardNo')}
                      component={InputText}
                    />
                  </div>

                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label='Tiểu khoản TPBank'
                      inputProps={getInputProps('accountNumber')}
                      component={InputText}
                    />
                  </div>
                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label={'Tiểu khoản BIDV'}
                      inputProps={getInputProps('bidvVaPayerId')}
                      component={InputText}
                    />
                  </div>

                  {/* <div className="col-sm-6 col-lg-4">
                    <InputWraper label="Vai trò" inputProps={getInputProps("role")} component={InputText} />
                  </div> */}

                  {/* <div className="col-sm-6 col-lg-4">
                    <InputWraper label="Trưởng nhóm" inputProps={getInputProps("leaderName")} component={InputText} />
                  </div>

                  <div className="col-sm-6 col-lg-4">
                    <InputWraper label="Tài khoản trưởng nhóm" inputProps={getInputProps("leaderPhoneNumber")} component={InputText} />
                  </div> */}

                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label='Hợp tác xã'
                      inputProps={getInputProps('compName')}
                      component={InputText}
                    />
                  </div>

                  {/* <div className="col-sm-6 col-lg-4">
                    <InputWraper label="Phòng ban" inputProps={getInputProps("agencyName")} component={InputText} />
                  </div> */}

                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label={'Trạng thái'}
                      inputProps={getInputProps('isActive')}
                      component={InputText}
                    />
                  </div>
                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label={'Mã giới thiệu của tôi'}
                      inputProps={getInputProps('myRefferId')}
                      component={InputText}
                    />
                    <div
                      style={{
                        cursor: 'pointer',
                        color: '#007bff',
                        position: 'absolute',
                        right: '30px',
                        top: '45%',
                      }}
                      onClick={() => setIsOpenModal(true)}
                    >
                      <Icon.ViewDetailIcon />
                    </div>
                  </div>
                  <div className='col-sm-6 col-lg-4'>
                    <InputWraper
                      label={'Email'}
                      inputProps={getInputProps('email')}
                      component={InputText}
                    />
                  </div>

                  <div className='col-12 primary-info__general-info__field--button'>
                    <Button
                      type='submit'
                      isLoading={isLoadingMutateProfile}
                      buttonType='success'
                      label='Cập nhật'
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Loading>
      <ModalMyRefferal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      />
    </div>
  );
};

export default UserInfoFeature;
